import { React, useState } from 'libs/react';
import { useDealConfiguratorContext } from '../../../DealConfigureScreen';
import { CustomFieldForm } from 'components/field/form/CustomFieldForm';
import { useParams } from 'react-router-dom';
import './DealAdditionalInformationPanel.scss';
/**
 * @component DealAdditionalInformationPanel.tsx
 * @since 1.0.0
 */
export function DealAdditionalInformationPanel(props) {
    const { dataFieldGroup } = props;
    const { id } = useParams();
    const entity = 'DEAL';
    const { deal, updateDealFieldValues } = useDealConfiguratorContext();
    const [dealFieldValues, setDealFieldValues] = useState([]);
    /**
     * @function updateFieldValues
     * @since 1.0.0
     */
    function updateFieldValues(values) {
        const tempDealFieldValues = [...dealFieldValues];
        const existingField = dealFieldValues.find((field) => Object.keys(field)[0] === Object.keys(values)[0]);
        if (existingField) {
            const index = dealFieldValues.indexOf(existingField);
            tempDealFieldValues[index] = values;
        }
        else {
            tempDealFieldValues.push(values);
        }
        setDealFieldValues(tempDealFieldValues);
        updateDealFieldValues(values, Object.keys(values)[0]);
    }
    const mergedValues = dataFieldGroup.fieldGroups.map((group) => {
        return Object.assign(Object.assign({}, group), { fields: group.fields.map((field) => {
                var _a, _b;
                const corrrespondingField = (_a = deal === null || deal === void 0 ? void 0 : deal.fieldValues) === null || _a === void 0 ? void 0 : _a.find((value) => value.field.id === field.id);
                return Object.assign(Object.assign({}, field), { value: (_b = corrrespondingField === null || corrrespondingField === void 0 ? void 0 : corrrespondingField.value) !== null && _b !== void 0 ? _b : null });
            }) });
    });
    return (React.createElement("div", { className: "deal-additionnal-information-panel" },
        React.createElement(CustomFieldForm, { entity: entity, entityId: id, fields: mergedValues, hideGroupTitle: true, onChange: updateFieldValues, functionValue: deal === null || deal === void 0 ? void 0 : deal.subtotal.toString(), translable: false })));
}
